import {Component, OnInit} from '@angular/core';

import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';
import {Usuario} from '../../../_model/Usuario';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-clientes-obra',
  templateUrl: './clientes-obra.component.html',
  styleUrls: ['./clientes-obra.component.scss']
})
export class ClientesObraComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();

    audio;
    FORMS: any;
    API: any;
    CODFUNC: any;
    PAGE: any;
    GENERALES: any;
    tipoDeCliente = '';
    public usuario: Usuario = new Usuario();
    clientesArray = [];
    clientesArrayReverse = [];

  constructor(
        private network: NetworkHelperService,
        private router: Router,
  ) {
        this.FORMS = FORMS;
        this.API = API;
        this.CODFUNC = CODFUNC;
        this.GENERALES = GENERALES;
        this.PAGE = PAGE;
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
   }

  ngOnInit() {
  //this.getPermisos();
  this.getClientes();
  this.inverse();
  }

  getClientes() {
    this.network.callSecureService(
        this.API.user.sucursales + '/' + this.usuario.sucId + '/' + this.API.user.clientes,
        'GET',
        null)
        .subscribe((response: any) => {
          console.log(response);
                    const responseMensaje = response.Mensaje.reverse();
                    //let incremento = 1;
                    this.clientesArray = response.Mensaje;
                    console.log( this.clientesArray );
                this.dtTrigger.next();
            }, err => {
                console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }
    inverse() {
      this.clientesArrayReverse = this.clientesArray.reverse();
  }

  clienteSeleccionado(cliente: any) {
    this.router.navigate(['dashboard/menuAlmacen/clientesObra', cliente.id ]);
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/clientes-obra/clientes-obra.component.ts